/**
 * TODO temporary mapping for user friend error messages. Error messaging should be
 * pushed up to Proxy Service instead of client side.
 */
class ErrorMessage {
  static map(code, message) {
    switch (code) {
      case '401':
      case '422':
        return 'Invalid username or password';
      case '409':
        return 'This user already exists, try logging in.';
      case '404':
        return "Sorry. We don't have a Fender Connect account with that email.";
      default:
        return message;
    }
  }
}

export default ErrorMessage;
